import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './DriverTestimonials.style';

const DriverTestimonials = () => {
  const classes = useStyles();
  return (
    <Grid container justify='center' alignItems='center' className={classes.container}>
      <Grid item xs={12} className={classes.subsection}>
        <Typography variant='h4' className={classes.title} align='center'>
          Why Our Drivers Love Us?
        </Typography>
      </Grid>
      <Grid item xs={12} md={8} className={classes.subsection}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <div className={classes.quote}>
              <span className={classes.quotationMark}>
                <img src='/driver/quote-symbol.svg' width='28' height='23' />
              </span>
              <span className={classes.quoteText}>
                I love driving for Chowbus, and the managers are excellent to me, I feel I am part
                of one nice and good team.&rdquo;
              </span>
              <div className={classes.quoteName}>&mdash;Andrew</div>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.quote}>
              <span className={classes.quotationMark}>
                <img src='/driver/quote-symbol.svg' width='28' height='23' />
              </span>
              <span className={classes.quoteText}>
                I have absolutely loved my experience. From the customers to the business owners,
                everyone is incredibly friendly. The app is incredibly user friendly and I’ve really
                enjoyed working for Chowbus.&rdquo;
              </span>
              <div className={classes.quoteName}>&mdash;Eric</div>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DriverTestimonials;
